import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { Icons } from "./../Icons";
import moment from "moment";
import ModalTrazabilidad from "./../ModalTrazabilidad";
import { useNavigate } from "react-router-dom";
import { FlujoMontosPE } from "../../services/PpafeServicesPE";
import { puedeBaja } from "../../utils/permisosFlujo";

interface ColumnsProps {
  handleVerClick: (uuid: string, link: string) => void;
  urlOrigen?: string;
  navigate: (path: string) => void; // Agregar navigate como parámetro
}

const getColumnsMontosPE = ({
  handleVerClick,
  urlOrigen,
  navigate, // Recibir navigate como argumento
}: ColumnsProps): GridColDef[] => {

  const flujoDetalle = (accion: "avanzar" | "devolver", id: string) => {
    const tipo = "participaciones";
    const origen = "estatales";

    FlujoMontosPE(tipo, origen, () => { }, () => { }, () => { }, "ELIMINAR", id || "", accion);
  };

  const openSolicitud = (v: any) => {
    const url = `/admin/participaciones/estatales/verificacionmontospe/` + v;
    navigate(url);
  };
  return [
    {
      field: "acciones",
      headerName: "Acciones",
      headerAlign: "left",
      width: 300,
      sortable: false,
      hideable: false,
      renderCell: (cellValues: any) => {
        const isDisabled = cellValues.row.estatus?.toLowerCase() === "oculto";
        return (
          <Box display="flex" alignItems="center">
            {
              puedeBaja() &&

              <Box sx={{ paddingLeft: "5px" }} ml={2}>
                <Tooltip title="Baja" placement="top">
                  <IconButton onClick={() => flujoDetalle("avanzar", cellValues.row.id)} color="primary" disabled={isDisabled}>
                    {Icons("DeleteForever")}
                  </IconButton>
                </Tooltip>
              </Box>
            }


            <Box sx={{ paddingLeft: "5px" }} ml={2}>
              <Tooltip title="Abrir Registro" placement="top">
                <IconButton onClick={() => {
                  openSolicitud(cellValues.row.id)
                }} color="primary">
                  {Icons("Description")}
                </IconButton>
              </Tooltip>
            </Box>


            <Box sx={{ paddingLeft: "5px" }} ml={1}>
              <Tooltip title="Trazabilidad" placement="top">
                <ModalTrazabilidad uuid={cellValues.row.id} urlOrigen={urlOrigen} />
              </Tooltip>
            </Box>

            <Box sx={{ paddingLeft: "5px" }} ml={2}>
              {/* Ejemplo de otro icono con onClick */}
              <Tooltip title="Semaforización" placement="bottom">
                <IconButton color="primary">
                  {Icons("CheckCircle")}
                </IconButton>
              </Tooltip>
            </Box>


          </Box>
        );
      },
    },
    {
      field: "titulo",
      headerName: "Titulo del Documentos",
      width: 600,
      hideable: false,
      headerAlign: "left",
      renderCell: (cellValues: any) => {
        return (
          <Tooltip title={cellValues.value}>
            {cellValues.value}
          </Tooltip>
        );
      },
    },
    {
      field: "fecha",
      headerName: "Fecha",
      width: 100,
      hideable: false,
      headerAlign: "left",
      renderCell: (cellValues: any) => {
        const fechaFormateada = moment.utc(cellValues.value).format("DD/MM/YYYY");
        return (
          <Tooltip title={fechaFormateada}>
            <span>{fechaFormateada}</span>
          </Tooltip>
        );
      }
    },
    {
      field: "estatus",
      headerName: "Estatus",
      width: 100,
      hideable: false,
      headerAlign: "left",
      renderCell: (cellValues: any) => {
        const estatus = cellValues.row.estatus?.toLowerCase() === "oculto" ? "BAJA" : cellValues.row.estatus;
        return (
          <Tooltip title={estatus}>
            <span>{estatus}</span>
          </Tooltip>
        );
      }
    },

  ];
};

export default getColumnsMontosPE;
